webpackJsonp([179788616296006],{

/***/ 1869:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"MonographGuide","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"plumbsId","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"title","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-monograph-guide-383cf4326809533d1c5b.js